module.exports = __webpack_public_path__ + "static/media/ipo9.4a8ec778.png";